import {
  Identifiable,
  Planzone,
  ResourcesListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateResourcesListingConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: ResourcesListingConfiguration,
    nextConfiguration: ResourcesListingConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          resourcesListingViewConfigurations: JSON.stringify(nextConfiguration),
        },
      },
    });
}

export { updateResourcesListingConfiguration };
